import { EditPractitionerPage } from '@/pages/Practitioners/EditPractitioner';
import { createFileRoute } from '@tanstack/react-router';

const RouteComponent = (): React.ReactNode => {
  // oxlint-disable-next-line no-use-before-define
  const { practitionerId } = Route.useParams();
  return <EditPractitionerPage practitionerId={practitionerId} />;
};

export const Route = createFileRoute('/_auth/practitioners/$practitionerId/')({
  component: RouteComponent,
});
